import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-wave",
  "use": "icon-si-glyph-arrow-wave-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-wave\" id=\"icon-si-glyph-arrow-wave\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1029</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M14.031,7.125 L14.031,9 L11.969,9 L11.965,5 L8.016,5 L8.043,11 L5.984,11 L5.98,7.031 L2.035,7.031 L2.031,9 L1.004,9 L1.004,10 L2.953,10 L2.957,8 L5.027,8 L5.031,12 L8.953,12 L8.957,6 L11.016,6 L11.02,10 L14.031,10 L14.031,11.958 L17,9.5 L14.031,7.125 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-wave.svg
// module id = il3Q
// module chunks = 62